import HttpRequest from 'helper-xhr';

import {
  GET_CARS_FAIL, GET_CARS_SUCCESS, CARS_IS_LOADING,
  GET_CARDETAILS_SUCCESS, SAVE_SELECTEDCAR, SAVE_SELECTEDDIAMETERS,
  UPDATE_UI_SUCCESS, ACTN_REFRESH
} from "./action-types.js";

export const getCars_FAIL = error => ({ type: GET_CARS_FAIL, error: error });
export const getCars_SUCCESS = cars => ({ type: GET_CARS_SUCCESS, cars: cars });
export const updateUI_SUCCESS = data => ({ type: UPDATE_UI_SUCCESS, data: data });
export const carsIsLoading = isLoading => ({ type: CARS_IS_LOADING, isLoading: isLoading });

export const getCarDetails_SUCCESS = carDetails => ({ type: GET_CARDETAILS_SUCCESS, carDetails: carDetails });
export const saveSelectedCar = selectedCar => ({ type: SAVE_SELECTEDCAR, selectedCar: selectedCar });

// export const saveUpdateValue = updateValue => ({ type: ACTN_REFRESH, data: { updateValue: updateValue } });

const carsFetchData = (makerModelYear) => {
  return (dispatch) => {
    //we should check if is already loading
    dispatch(carsIsLoading(true));
    var protocol = "GET";
    var payload = null;
    if (makerModelYear) {
      protocol = "POST";
      payload = makerModelYear;
    }
    var xhr = new HttpRequest(protocol, '/ajax/cars/maker-model-year', "application/json");
    return xhr.send(payload)
      .then((response) => {
        var json = response.json;
        if (json.message || json.exception || json.error) {
          dispatch(getCars_FAIL(json.message || json.exception || json.error));
          //throw Error(json.message || json.exception || json.error);
        }
        dispatch(carsIsLoading(false));
        if (makerModelYear) {
          dispatch(getCarDetails_SUCCESS(json))
        } else {
          dispatch(getCars_SUCCESS(json))
        }

        return response;
      }, (error) => {
        console.log(error);
        dispatch(getCars_FAIL(error));
      });
  };
}

const updateUIData = (data) => {
  return (dispatch) => {
    dispatch(updateUI_SUCCESS(data))
  };
}

// trasformare la chiamata utilizzando la nuovo doSomething

export const getCars = (makerModelYear) => (dispatch, getState) => {
  return dispatch(carsFetchData(makerModelYear))
}

export const updateUI = (data) => (dispatch, getState) => {
  return dispatch(updateUIData(data))
}

